export const GET_PROJECT = "GET_PROJECT";
export const PROJECT_FAILURE = "PROJECT_FAILURE";
export const PROJECT_SUCCESS = "PROJECT_SUCCESS";
export const ADD_PROJECT_LOADING = "ADD_PROJECT_LOADING";
export const USER_PROJECTS_SUCCESS = "USER_PROJECTS_SUCCESS";
export const USER_PROJECTS_LOADING = "USER_PROJECTS_LOADING";
export const USER_PROJECTS_ERROR = "USER_PROJECTS_ERROR";
export const ACTIVITIES_SUCCESS = "ACTIVITIES_SUCCESS";
export const ACTIVITIES_FAILURE = "ACTIVITIES_FAILURE";
export const ACTIVITIES_LOADING = "ACTIVITIES_LOADING";
export const FETCH_ACTIVITIES_LOADING = "FETCH_ACTIVITIES_LOADING";
export const GET_USER_LOADING = "GET_USER_LOADING";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";
export const COMPLETE_EDIT_PROJECT = "COMPLETE_EDIT_PROJECT";
export const COMPLETE_EDIT_PROJECT_FAIL = "COMPLETE_EDIT_PROJECT_FAIL";
